export default __webpack_public_path__ + "static/granular-gradient-773390684801d3bd9837e4e1aeb56411.svg";